/* istanbul ignore file */
import React from 'react';
import { InputList, InputListProps } from 'framework/form';

const AdditionalVacancyQuestionOptionList = (props: InputListProps) => {
  return <InputList {...props} maxFields={10} />;
};

export default AdditionalVacancyQuestionOptionList;
